import { ERROR_COLORS, PRIMARY_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import { NEW_SEO } from 'routes/constants.routes'

export const ACTIVE = 'ACTIVE' // ACTIVE
export const ALL = 'ALL' // Все
export const DEMONSTRATION = 'DEMONSTRATION' // Демонстрация
export const HOLD = 'HOLD' // В Работе
export const ISSUE = 'ISSUE' // Выдача
export const MISSED = 'MISSED' // Упущен
export const OKTELL = 'OKTELL' // Oktell
export const PAYMENT = 'PAYMENT' // Оформление
export const SELECTION = 'SELECTION' // Выбор авто
export const SUCCESS = 'SUCCESS' // Продажа
export const SMM = 'SMM' // Продажа

export const AllStatusesDeal = [
  {
    saleStatusTrackCode: 50,
    code: DEMONSTRATION,
    name: 'Демонстрация'
  },
  {
    saleStatusTrackCode: 60,
    code: SELECTION,
    name: 'Выбор авто для продажи'
  },
  {
    code: HOLD,
    name: 'В Работе'
  },
  {
    code: OKTELL,
    name: 'РЛ Октелл'
  },
  {
    code: MISSED,
    name: 'Упущен'
  },
  {
    code: SUCCESS,
    name: 'Продажа'
  },
  {
    code: PAYMENT,
    name: 'Оформление'
  },
  {
    code: SMM,
    name: 'SMM'
  }
]

export const taskTypes = [
  {
    code: false,
    name: 'Открытые'
  },
  {
    code: true,
    name: 'Закрытые'
  }
]

export const colorStatusesByCode = code => {
  const colors = {
    [MISSED]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[700]
    },
    [HOLD]: {
      backgroundColor: PRIMARY_COLORS[50],
      color: PRIMARY_COLORS[700]
    },
    [SUCCESS]: {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700]
    },
    [PAYMENT]: {
      backgroundColor: PRIMARY_COLORS[50],
      color: PRIMARY_COLORS[700]
    },
    [ISSUE]: {
      backgroundColor: PRIMARY_COLORS[50],
      color: PRIMARY_COLORS[700]
    },
    [DEMONSTRATION]: {
      backgroundColor: PRIMARY_COLORS[50],
      color: PRIMARY_COLORS[700]
    },

    [SELECTION]: {
      backgroundColor: PRIMARY_COLORS[50],
      color: PRIMARY_COLORS[700]
    }
  }

  return code ? colors?.[code] : colors?.[HOLD]
}

export const STATUS_TRACK = {
  10: { id: 1, name: 'У менеджера' },
  20: { id: 2, name: 'В очереди на консультацию' },
  30: { id: 3, name: 'На консультации' },
  40: { id: 4, name: 'У менеджера после консультации' },
  50: { id: 18, name: 'Демонстрация' },
  60: { id: 19, name: 'Выбор авто для продажи' },
  70: { id: 20, name: 'Подбор авто' },
  80: { id: 21, name: 'Утверждение закрытие' },
  90: { id: 22, name: 'Утверждение скидки' },
  100: { id: 23, name: 'SERVICE_COMPLETED' }
}

export const STEPPER_STATUS = [70, 50, 60, 90]

export const getPrevStepByStatus = (statusCode, statusTrackCode) => {
  const a = Number(statusTrackCode || 0)
  if (statusCode === PAYMENT || a === 110) {
    return 3
  }
  if (a !== 0) {
    const step = STEPPER_STATUS.findIndex(v => v === a)
    return step === -1 ? 0 : step
  }

  if (!statusCode && !statusTrackCode) {
    return NEW_SEO
  }
  return 0
}
